export default "__VITE_ASSET__DMxgWQo___"